<script>
import router from "@/router";
import {mapActions} from "vuex";

export default {
  name: "WishListsWrapper",
  props: {
    slicer: {
      default: Infinity,
    },
    itemType: {
      default: 'product',
      validator(value) {
        // The value must match one of these strings
        return ['brand', 'product', 'category'].includes(value)
      }
    },
    user_id: {
      default: null
    }
  },
  data() {
    return {
      form: {
        id: this.item_id,
        user_id: this.user_id,
        page: 1
      },
      wishListItems: [],
      paginationMeta: [],
    }
  },
  computed: {
    setWishListUser() {
      /* check wish-List archive */
      return this.user_id != undefined ? this.user_id : this.$route.params.user
    }
  },
  methods: {
    ...mapActions({
      removeItemFromWishList: 'WishList/removeItemFromWishList'
    }),
    async changePage(page) {
      this.form.page = page

      await this.initWrapper()

    },
    async setWishlistItems() {

      this.form.user_id = this.setWishListUser
      let response = await this.$store.dispatch('WishList/loadUserWishList', this.form)

      let data = response.data.data

      this.wishListItems = data.data
      this.paginationMeta = data.meta
      this.$emit("wishListItems", this.wishListItems);
    },
    async initWrapper() {
      await this.setWishlistItems()
    },
    removeItemFromWishListWrapper(item) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        let req = this.removeItemFromWishList(item)
        req.then(res => {
          this.initWrapper();
        })
      }

    }
  },
  render() {
    return this.$slots.default({
      wishListItems: this.wishListItems != undefined ? this.wishListItems.slice(0, this.slicer) : [],
      pagination: this.paginationMeta,
      changePageFunction: this.changePage,
      removeItem: this.removeItemFromWishListWrapper
    });
  },
  async mounted() {
    await this.initWrapper();
  },
}
</script>
